module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 0iPh
// module chunks = 154